import { createSlice } from '@reduxjs/toolkit';

import { MapState } from '../../types';

import {
  MAP_STATE,
  MAP_NAMES
} from '../../constants';

import { mapLocalStorage } from '../../utils'

import { createRoutePoint } from '../../utils';

import { setInitializedMap } from './setInitializedMap';
import { setSelectedPoint } from './setSelectedPoint';
import { setRoutePoints } from './setRoutePoints';
import { setShowStreetView } from './setShowStreetView';
import { setFocusPoint } from './setFocusPoint';

const DEFAULT_MAP = MAP_NAMES.here;

const initialState: MapState = {
  initialized: false,
  showStreetView: false,
  name: mapLocalStorage.getName() || DEFAULT_MAP,
  routes: {
    filter: {
      routePoints: [createRoutePoint(), createRoutePoint()]
    }
  }
};

export const mapSlice = createSlice({
  name: MAP_STATE,
  initialState,
  reducers: {
    setInitializedMap,
    setSelectedPoint,
    setRoutePoints,
    setShowStreetView,
    setFocusPoint
  }
});

export const mapActions = mapSlice.actions;
export const mapReducer = mapSlice.reducer;
